import React, { useState } from "react";
import { useCreateSubscriptionMutation } from "../../redux/Slices/subscriptionApi";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress,
  Alert,
  Container,
  Paper,
} from "@mui/material";
import Button from "../../components/styled-component/ReusableButton";
import { useGetPlansQuery } from "../../redux/Slices/plans";
import { useMaterialUIController } from "context";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const SubscriptionForm = ({ open, onClose, store }) => {
  const [controller] = useMaterialUIController();
    const darkMode = controller.darkMode;
    const theme = useTheme();
  console.log("store id", store?.id);
  const [storeId, setStoreId] = useState(store?.id);
  console.log("🚀 ~ SubscriptionForm ~ storeId:", storeId);
  console.log(open);


  const [formData, setFormData] = useState({
    store_id: storeId,
    plan_id: "",
    start_date: "",
    end_date: "",
    status: "active",
    auto_renew: true,
  });
  console.log("🚀 ~ SubscriptionForm ~ formData:", formData);

  const { data: plans, isLoading: isPlansLoading, error: plansError } = useGetPlansQuery();
  const [createSubscription, { isLoading: isSubmitting, error: submitError, isSuccess }] =
    useCreateSubscriptionMutation();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("store id before send", formData);

      await createSubscription(formData).unwrap();
      setFormData({
        store_id: store.id,
        plan_id: "",
        start_date: "",
        end_date: "",
        status: "active",
        auto_renew: true,
      });
    } catch (err) {
      console.error("Failed to create subscription:", err);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "10vh",
          borderRadius: "16px",
         
          
         
          overflow: "auto",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        <CloseIcon sx={{ color: "text.main" }} />
      </IconButton>

      

      {isSuccess && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Subscription created successfully!
        </Alert>
      )}
      {submitError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Error: {submitError?.data?.message || "Failed to create subscription"}
        </Alert>
      )}
      {plansError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Error: {plansError?.data?.message || "Failed to load plans"}
        </Alert>
      )}

      <Box
        component="form"
        onSubmit={handleSubmit}
        p={2}
        sx={{ 
          display: "flex", flexDirection: "column", gap: 2,
           bgcolor: darkMode ? theme.palette.background.default : "background.paper",
 color: darkMode ? "white !important" : "inherit",
         }}
      ><Typography variant="h5" align="right" gutterBottom>
        انشاء اشتراك
      </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <FormControl fullWidth required>
            <InputLabel>الخطة</InputLabel>
            <Select
              name="plan_id"
              value={formData.plan_id}
              onChange={handleChange}
              label="Plan"
              sx={{ paddingBlock: 1 }}
            >
              <MenuItem value="">اختر الخطة</MenuItem>
              {isPlansLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} />
                </MenuItem>
              ) : (
                plans?.data?.map((plan) => (
                  <MenuItem key={plan.id} value={plan.id}>
                    {plan.name}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>الحالة</InputLabel>
            <Select
              name="status"
              value={formData.status}
              onChange={handleChange}
              label="Status"
              sx={{ paddingBlock: 1 }}
            >
              <MenuItem value="active">نشط</MenuItem>
              <MenuItem value="inactive">غير نشط</MenuItem>
              <MenuItem value="cancelled">ملغي</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <TextField
          type="date"
          name="start_date"
          label="تاريخ البدء"
          value={formData.start_date}
          onChange={handleChange}
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
        />

        <TextField
          type="date"
          name="end_date"
          label="تاريخ الانتهاء"
          value={formData.end_date}
          onChange={handleChange}
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
        />

        <FormControlLabel
          control={
            <Checkbox name="auto_renew" checked={formData.auto_renew} onChange={handleChange} />
          }
          label="تجديد التلقائي"
        />

        <Button
          type="submit"
          variant="primary"
          mt={2}
          disabled={isSubmitting}
          style={{ marginRight: "auto", width: "40%" }}
          onClick={handleSubmit}
        >
          {isSubmitting ? "جاري الحفظ..." : "حفظ التغييرات"}
        </Button>
      </Box>
    </Dialog>
  );
};

export default SubscriptionForm;
